import * as React from 'react';
import { useEffect, useState } from 'react';
import { DataTable } from 'react-native-paper';
import CalCalDataApi from '../../api/CalCalDataApi';
import Table from '../../components/table';
import { isArray } from 'lodash';

export default function TableRemote({ apiPath, jwt, cols, rowAlt, filter }) {
	const [data, setData] = useState([]);
	const [page, setPage] = useState(0);
	const [sort, setSort] = useState('expenseDate');
	const [direction, setDirection] = useState('ascending');
	const [fetching, setFetching] = useState(false);
	const [atLastPage, setAtLastPage] = useState(false);
	const PAGESIZE = 50;

	const [lastFilter, setlastFilter] = useState();

	useEffect(() => {
		const thisFetch = `${page} ${sort} ${direction} ${filter}`;
		if (fetching == thisFetch) return;
		__DEV__ && console.log(thisFetch, fetching);
		setFetching(thisFetch);
		if (filter != lastFilter && page != 0) {
			setPage(0);
			return;
		}

		CalCalDataApi.dataLoad(`${apiPath}/${filter}/sort:${sort}:${direction == 'ascending' ? 'A' : 'D'}/top:${page * PAGESIZE},${PAGESIZE}`, jwt, res => {
			if (isArray(res)) setData(filter == lastFilter ? [...data, ...res] : res);
			setAtLastPage(res.length < PAGESIZE);
			setlastFilter(filter);
		});
	}, [page, sort, direction, filter]);

	const changeSort = sortby => {
		setData([]);
		if (sortby == sort) {
			setDirection(direction == 'ascending' ? 'descending' : 'ascending');
		} else {
			setDirection('ascending');
		}
		setPage(0);
		setAtLastPage(false);
		setSort(sortby);
	};

	return (
		<Table
			cols={cols}
			sort={sort}
			direction={direction}
			setSort={changeSort}
			data={data}
			loading={!lastFilter}
			loadMoreData={() => !atLastPage && setPage(page + 1)}
			//colAlt="#EEE"
			rowAlt={rowAlt}
		/>
	);
}
